module.exports = __webpack_public_path__ + "static/media/clcontact.88cb37fd.jpg";